import { Component, OnInit, Input, Injector, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { LoaderService } from 'src/modules/base/services/loader.service';

@Component({
    selector: 'app-patient-uhid-merge',
    templateUrl: './patient-uhid-merge.component.html',
    styleUrls: ['./patient-uhid-merge.component.scss'],
    standalone: false
})
export class PatientUhidMergeComponent implements OnInit, AfterViewInit {
  config = {
    "submitButton": true,
    "cancelButton": true,
    "filterForm": false,
    "clearOnSave": true,
    "delegateSave": true,
    "cancelRoute": ''
  }
  @ViewChild('formselection') formselection: any;
  @Input() data: any;
  currentData: any = {};
  _currentData: any = false;
  id: any; emptObj: any = {};
  form_data: any;
  uhId: any;
  FormObj: any;
  action: any;
  primary_uhId: any;
  secondary_uhId = [];
  arr: any;
  datasource: any = { possible_value: [] };
  btn = {
    "Add": [
      {
        "label": "Save",
      }
    ],
    "Modify": [
      {
        "label": "Update",
      }
    ]
  };

  constructor(
    private baseService: BaseService,
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    private alerts: AlertsService,
    private dialogRef: DialogRef,
    public loader: LoaderService
  ) { }

  ngAfterViewInit(): void {
    if (this.action.resource && this.action.resource == "ivf_patient" && this.baseService && this.baseService._resourceName != undefined && this.baseService._resourceName == "ivf_patient_registration") {
      this.formselection.el.nativeElement.querySelector("#id_check").insertAdjacentHTML('afterbegin', " <i class='fa fa-plus-circle text-danger'></i> ");
      this.formselection.el.nativeElement.querySelector("#spouse_id_check").insertAdjacentHTML('afterbegin', " <i class='fa fa-anchor text-danger'></i> ");
      this.formselection.el.nativeElement.querySelector("#donor_id_check").insertAdjacentHTML('afterbegin', " <i class='fa fa-asterisk text-danger'></i> ");
      this.formselection.el.nativeElement.querySelector("#surrogate_id_check").insertAdjacentHTML('afterbegin', " <i class='fa fa-bookmark text-danger'></i> ");
    } // Add New patient for capability click Start
    if (this.baseService && this.baseService._resourceName != undefined && this.baseService._resourceName == "add_ivf_patient") {
      this.formselection.el.nativeElement.querySelector("#spouse_id_check").insertAdjacentHTML('afterbegin', " <i class='fa fa-anchor text-danger'></i> ");
      this.formselection.el.nativeElement.querySelector("#donor_id_check").insertAdjacentHTML('afterbegin', " <i class='fa fa-asterisk text-danger'></i> ");
      this.formselection.el.nativeElement.querySelector("#surrogate_id_check").insertAdjacentHTML('afterbegin', " <i class='fa fa-bookmark text-danger'></i> ");
    } // Add New patient for capability click End
  }

  ngOnInit() {
    for (let data of this.data) {
      if (data.uhId) {
        this.datasource.possible_value.push({ id: data.id, value: data.patient_name + " | " + data.uhId + " | " + data.patient_gender })
      }
    }

    if (this.action.resource && this.action.resource == "ivf_patient" && this.baseService && this.baseService._resourceName != undefined && this.baseService._resourceName == "ivf_patient_registration") {
      this.FormObj = {
        "blocks": [
          {
            "name": "patient_uhid_merge",
            "class_name": "null",
            "order": 1,
            "title": "",
            "layout_type": "two-column",
            "fields": [
              {
                "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix full-width-items",
                "order": 1,
                "type": "String",
                "required": true,
                "datasource": this.datasource,
                "component": "radio",
                "name": "id",
                "label": "field.label.select_default"
              },
              {
                "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix full-width-items",
                "order": 1,
                "type": "String",
                "required": false,
                "datasource": this.datasource,
                "component": "radio",
                "name": "spouse_id",
                "label": "field.label.choose_one_uhid_to_mark_as_spouse"
              },
              {
                "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix full-width-items",
                "order": 1,
                "type": "String",
                "required": false,
                "datasource": this.datasource,
                "component": "radio",
                "name": "donor_id",
                "label": "field.label.choose_one_uhid_to_mark_as_donor"
              },
              {
                "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix full-width-items",
                "order": 1,
                "type": "String",
                "required": false,
                "datasource": this.datasource,
                "component": "radio",
                "name": "surrogate_id",
                "label": "field.label.choose_one_uhid_to_mark_as_surrogate"
              }
            ]
          }
        ]
      } // Add New patient for capability click  
    } else if (this.baseService && this.baseService._resourceName != undefined && this.baseService._resourceName == "add_ivf_patient") {
      this.FormObj = {
        "blocks": [
          {
            "name": "patient_uhid_merge",
            "class_name": "null",
            "order": 1,
            "title": "",
            "layout_type": "two-column",
            "fields": [
              {
                "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix full-width-items",
                "order": 1,
                "type": "String",
                "required": false,
                "datasource": this.datasource,
                "component": "radio",
                "name": "spouse_id",
                "label": "field.label.choose_one_uhid_to_mark_as_spouse"
              },
              {
                "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix full-width-items",
                "order": 1,
                "type": "String",
                "required": false,
                "datasource": this.datasource,
                "component": "radio",
                "name": "donor_id",
                "label": "field.label.choose_one_uhid_to_mark_as_donor"
              },
              {
                "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix full-width-items",
                "order": 1,
                "type": "String",
                "required": false,
                "datasource": this.datasource,
                "component": "radio",
                "name": "surrogate_id",
                "label": "field.label.choose_one_uhid_to_mark_as_surrogate"
              }
            ]
          }
        ]
      }
    } // Add New patient for capability click End
    else {
      this.FormObj = {
        "blocks": [
          {
            "name": "patient_uhid_merge",
            "class_name": "null",
            "order": 1,
            "title": "",
            "fields": [
              {
                "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix full-width-items",
                "order": 1,
                "type": "String",
                "required": true,
                "datasource": this.datasource,
                "component": "radio",
                "name": "id",
                "label": "field.label.choose_one_uhid_to_mark_as_default"
              }
            ]
          }
        ]
      }
    }

  }

  questionValueChanged(event: any) {
    // console.log("event is :: ",event);
    if (event && event.question.val) {
      this.emptObj[event.question.question.key] = event.question.val
    }
  }

  closePopup() {
    this.dialogRef.close();
  }

  onSaveFinished(data) {
    this.loader.showSpinner();
    let query_id = "MERGE_UHID"; let resource = "patient_uhid_merge"
    //this.secondary_uhId = [];
    for (let i = 0; i < this.data.length; i++) {
      //this.id += this.data[i].id;
      var row = this.data[i];
      if (row != undefined && row.id != undefined && row.id != data.result['id']) {
        this.uhId = row.uhId;
        this.secondary_uhId.push(this.uhId);
        console.log("this.secondary_uhId", this.secondary_uhId);
      }
      else {
        this.primary_uhId = this.data[i].uhId;
      }
    }

    var obj = {};
    if (this.action.resource && this.action.resource == "ivf_patient" && this.baseService && this.baseService._resourceName != undefined && this.baseService._resourceName == "ivf_patient_registration") {
      if (this.data.find(x => x.id == this.emptObj.id).gender_id != "female") {
        this.alerts.info("Primary patient must be Female");
        this.loader.hideSpinner();
        return
      }
      query_id = "IVF_PATIENT_GENERATION";
      resource = "ivf_patient";
      if (this.emptObj.id)
        obj['primary_uhId'] = this.data.find(x => x.id == this.emptObj.id).uhId;
      if (this.emptObj.spouse_id)
        obj['spouse_uhId'] = this.data.find(x => x.id == this.emptObj.spouse_id).uhId
      if (this.emptObj.donor_id)
        obj['donor_uhId'] = this.data.find(x => x.id == this.emptObj.donor_id).uhId
      if (this.emptObj.surrogate_id)
        obj['surrogate_uhId'] = this.data.find(x => x.id == this.emptObj.surrogate_id).uhId

      let Arr = [];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id == this.emptObj.id || this.data[i].id == this.emptObj.spouse_id || this.data[i].id == this.emptObj.donor_id || this.data[i].id == this.emptObj.surrogate_id) {
        } else {
          Arr.push(this.data[i].id)
        }
      }
      obj['patient_id'] = Arr;
    } // Add New patient for capability click
    else if (this.baseService && this.baseService._resourceName != undefined && this.baseService._resourceName == "add_ivf_patient") {
      query_id = "ADD_IVF_PATIENT";
      resource = "ivf_patient";
      obj['ivf_no'] = this.route.snapshot.queryParams.ivf_no // ivf No 
      if (this.emptObj.spouse_id)
        obj['spouse_uhId'] = this.data.find(x => x.id == this.emptObj.spouse_id).uhId
      if (this.emptObj.donor_id)
        obj['donor_uhId'] = this.data.find(x => x.id == this.emptObj.donor_id).uhId
      if (this.emptObj.surrogate_id)
        obj['surrogate_uhId'] = this.data.find(x => x.id == this.emptObj.surrogate_id).uhId
      let Arr = [];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id == this.emptObj.id || this.data[i].id == this.emptObj.spouse_id || this.data[i].id == this.emptObj.donor_id || this.data[i].id == this.emptObj.surrogate_id) {
        } else {
          Arr.push(this.data[i].id)
        }
      }
      obj['patient_id'] = Arr;
    } else {
      obj['patient_id'] = data.result['id'];
      obj['primary_uhId'] = this.primary_uhId;
      obj['secondary_uhId'] = this.secondary_uhId;
    }
    this.baseService.action(obj, query_id, "patient-registration", resource).subscribe(
      res => {
        this.loader.hideSpinner()
        if (res.errCode == 0) {
          this.alerts.success("Updated Successfully");// Add New patient for capability click 
          if (this.baseService && this.baseService._resourceName != undefined && this.baseService._resourceName == "add_ivf_patient") {
            this.goBack();
          } else {
            let currentUrl = this.router.url;
            this.router.navigate([this.route.snapshot.queryParams], { skipLocationChange: true }).then(() => {
              this.router.navigateByUrl(currentUrl);
            });
          }
        }
        else if (res.errCode == -1) {
          this.alerts.error(res.message);
        }
        this.closePopup();
      })
  }
  goBack() { // GO back function 
    if (this.route.snapshot.queryParams.hasOwnProperty('returnUrl')) {
      this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
    }
  }
}
